<template>
  <div class="text-info">
    <vs-col vs-type="flex">
      <span class="flex-1 text-info-title">
        <slot name="title">{{ title }}</slot>
      </span>
      <span class="flex-1 text-info-value">
        <slot name="value">{{ value }}</slot>
      </span>
    </vs-col>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: [String, Number]
  }
}
</script>

<style lang="scss">
.text-info {
  font-size: 1.6rem;

  .vs-col {
    float: none;
  }
}

.text-info-title {
  color: #97a3b4;
  font-size: 1.3rem;
  line-height: 1.6rem;
  font-weight: 600;
  margin-top: 1.4rem;
}

.text-info-value {
  color: #6d7588;
  font-size: 1.3rem;
  line-height: 1.6rem;
  font-weight: 600;
  margin-top: 1.4rem;
  word-wrap: break-word;
  width: 10rem;
}
</style>
